import { styled } from "@styles";
import { Row, Col } from "react-bootstrap";

export const Wrapper = styled.div``;

export const WrapperRow = styled(Row)``;

export const WrapperCol = styled(Col)``;

export const InnerRow = styled(Row)``;

export const InnerCol = styled(Col)``;

export const StarRatingWrapper = styled.div`
  height: 1rem;
  width: 100%;
  text-align: center;
  transform: scale(2);
  margin-top: 1rem;
  margin-bottom: 2rem;
`;